/**
 * Shared helpers for interpreting biz_email_log rows.
 */

export interface EmailLogEntry {
  id: string;
  emailType: string;
  entityType: string;
  entityId: string;
  recipientEmail: string;
  recipientName: string | null;
  subject: string;
  status: string;
  sendgridMessageId: string | null;
  sentAt: string | null;
  errorMessage: string | null;
  ownerId: string;
  createdAt: string;
}

export type DeliveryState = 'confirmed' | 'unconfirmed' | 'failed' | 'pending';

export const EMAIL_TYPE_LABELS: Record<string, string> = {
  invoice: 'Invoice',
  payment_reminder: 'Payment Reminder',
  overdue_notice: 'Overdue Notice',
  scheduled_report: 'Scheduled Report',
  notification: 'Notification',
};

/**
 * A row is only *confirmed* delivered to SendGrid when it carries a message id.
 * logAndSend() marks the row 'sent' even when SENDGRID_API_KEY is unset (the
 * dev no-op path), so status alone overstates what actually left the building.
 */
export function deliveryState(log: EmailLogEntry): DeliveryState {
  if (log.status === 'failed') return 'failed';
  if (log.status === 'pending') return 'pending';
  return log.sendgridMessageId ? 'confirmed' : 'unconfirmed';
}
